<div class="footer-container">
  <div class="container footer" [class.custom-design]="(siteSettings$ | async)?.switches?.custom_footer_design">
    <div
      [ngClass]="{ container: (siteSettings$ | async)?.switches?.custom_footer_design }"
      *ngIf="'custom_footer_image_overlay' | customImage | async as footerImage; else externalImage"
    >
      <div class="image-wrapper">
        <img [src]="footerImage.file" [alt]="footerImage.alt || 'footer image'" />
      </div>
    </div>
    <ng-template #externalImage>
      <div class="image-wrapper">
        <img class="external-image" alt="footer image" (load)="isImageLoaded = true" *ngIf="isImageLoaded" />
      </div>
    </ng-template>

    <div
      class="content-wrapper"
      [class.content-wrapper__image]="('custom_footer_image_overlay' | customImage | async) || isImageLoaded"
    >
      <ng-container
        *ngIf="
          (userAuthenticated$ | async) === false && (preloginFooterSection$ | async)?.content?.children;
          else footer
        "
      >
        <div
          *ngFor="let child of (preloginFooterSection$ | async)?.content?.children"
          class="footer-content container"
          [innerHTML]="child?.body | safeHtml"
        ></div>
      </ng-container>
      <ng-template #footer>
        <div
          *ngFor="let child of (footerSection$ | async)?.content?.children"
          class="footer-content container"
          [innerHTML]="child?.body | safeHtml"
        ></div>
      </ng-template>
      <div class="footer-links">
        <ul
          class="footer-links__list"
          [class.footer-links__list-image]="('custom_footer_image_overlay' | customImage | async) || isImageLoaded"
        >
          <ng-container *ngFor="let menu of secondaryMenuList$ | async">
            <li *ngIf="menu.isVisible" class="footer-links__list-item">
              <a
                href
                role="link"
                tabindex="0"
                class="footer__menu__a"
                [routerLink]="menu.routerLink"
                (accessibleClick)="navigate(menu.routerLink)"
              >
                {{ menu?.customName ? menu?.customName : (menu.translate | translate) }}
              </a>
            </li>
          </ng-container>

          <!--
          // @mlicciardi
          // REFACTOR
          // HARDCODED
          -->
          <li
            class="footer-links__list-item js-footer-dcr-cookie"
            *ngIf="
              (siteSettings$ | async)?.fe_configuration.path === 'visa-cemea' ||
              (siteSettings$ | async)?.fe_configuration.path === 'visa-lac'
            "
          >
            <a
              tabindex="0"
              aria-label="dcr-cookie"
              role="link"
              [translate]="'footercomponent:FooterDcrCookiePolicy'"
              href="//policy.cookiereports.com/{{ policyCode }}-{{ dcrCookieLanguage }}.html"
              class="footer__menu__a"
              >Cookie Policy</a
            >
          </li>
        </ul>

        <div
          class="recaptcha-wrapper"
          [ngClass]="{ 'd-none': !(siteSettings$ | async)?.switches?.custom_footer_design }"
          *ngIf="isReCaptchaFooter$ | async"
        >
          <div
            *ngFor="let child of (reCaptchaSection$ | async)?.content?.children"
            class="recaptcha"
            [innerHTML]="child?.body"
            tabindex="0"
          ></div>
        </div>
      </div>
      <div>
        <div
          *ngIf="
            (siteSettings$ | async)?.fe_configuration.show_platform_provider_footer &&
            (siteSettings$ | async)?.fe_configuration.platform_provider_type === platformProviderTypes.PROVIDER &&
            (siteSettings$ | async)?.switches?.access_to_HTR
          "
          class="platform-provider"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:ServiceProvidedBy'">Service provided by</div>
          <div
            role="img"
            class="platform-provider-footer-icon"
            [attr.aria-label]="'GlobalNav:BrandName' | translate"
          ></div>
        </div>
        <div
          *ngIf="
            (siteSettings$ | async)?.fe_configuration.show_platform_provider_footer &&
            (siteSettings$ | async)?.fe_configuration.platform_provider_type === platformProviderTypes.DELIVERED
          "
          class="platform-provider"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:DeliveredBy'">Delivered by Ten</div>
        </div>
      </div>
    </div>

    <div
      class="recaptcha-wrapper"
      [ngClass]="{ 'd-none': (siteSettings$ | async)?.switches?.custom_footer_design }"
      *ngIf="isReCaptchaFooter$ | async"
      tabindex="0"
    >
      <div
        *ngFor="let child of (reCaptchaSection$ | async)?.content?.children"
        class="recaptcha"
        [innerHTML]="child?.body"
      ></div>
    </div>
  </div>
</div>
